export default "__VITE_ASSET__a9f6170c__"